module.exports = __webpack_public_path__ + "img/portrait-099.b3ac2fcc.jpg";